// useAuthStore.ts — cookie session 模式（不再持久化 token）
import { defineStore } from 'pinia';
import { ref } from 'vue';
import api from '~/api';

export const useAuthStore = defineStore('authStore', () => {
    // token 字段保留以兼容旧代码引用，但实际不再使用；isLogin 由 /my/userinfo 决定
    const token = ref('');
    const isLogin = ref(false);

    const comm = useCommStore();

    async function login(_tk?: string) {
        // 旧调用：login(token) 后立即拉用户信息。新版：cookie 已由 server 写入，直接拉资料。
        isLogin.value = true;
        await comm.setUserInfo();
    }

    async function logout(redirectTo = '/') {
        const router = useRouter()
        try {
            await api.logout();
        } catch {/* ignore */}
        token.value = '';
        isLogin.value = false;
        comm.clearUserInfo();
        router.push(redirectTo)
    }

    /** App 启动时调一次：cookie 在则自动登录 */
    async function bootstrap() {
        try {
            await comm.setUserInfo();
            isLogin.value = true;
        } catch {
            isLogin.value = false;
        }
    }

    return {
        login,
        logout,
        bootstrap,
        token,
        isLogin
    };
});
